import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	addPeopleButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleGeneric: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionWithoutPageTitleGeneric: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionWithPageTitleGeneric: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionWithoutPageTitleGenericGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionWithPageTitleGenericGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addPeopleButton: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.add-people-button',
		defaultMessage: '{inviteeCount, plural, one {Add {displayName}} other {Add # people}}',
		description: 'CTA on a primary button to invite a group of people',
	},
	dismiss: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.dismiss',
		defaultMessage: "Don't show again",
		description: 'Secondary button to dismiss the flag permanently',
	},
	titleGeneric: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.title-generic',
		defaultMessage:
			'{inviteeCount, plural, one {{displayName} may need access} other {Your team may need access}}',
		description: 'Title of a flag pop up where the user can invite one or more users.',
	},
	descriptionWithoutPageTitleGeneric: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic',
		defaultMessage:
			'{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to <strong>{productDisplayName}</strong>.} other {# project assignees need access to <strong>{productDisplayName}</strong>.}}',
		description: 'Description of a flag pop up where the user can invite one or more users.',
	},
	descriptionWithPageTitleGeneric: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic',
		defaultMessage:
			'{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to {productDisplayName} to view <strong>{title}</strong>.} other {# project assignees need access to {productDisplayName} to view <strong>{title}</strong>.}}',
		description: 'Description of a flag pop up where the user can invite one or more users.',
	},
	descriptionWithoutPageTitleGenericGalaxia: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic-galaxia',
		defaultMessage:
			'{inviteeCount, plural, one {Your space assignee <strong>{displayName}</strong> needs access to <strong>{productDisplayName}</strong>.} other {# space assignees need access to <strong>{productDisplayName}</strong>.}}',
		description: 'Description of a flag pop up where the user can invite one or more users.',
	},
	descriptionWithPageTitleGenericGalaxia: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic-galaxia',
		defaultMessage:
			'{inviteeCount, plural, one {Your space assignee <strong>{displayName}</strong> needs access to {productDisplayName} to view <strong>{title}</strong>.} other {# space assignees need access to {productDisplayName} to view <strong>{title}</strong>.}}',
		description: 'Description of a flag pop up where the user can invite one or more users.',
	},
});
